import { forwardRef } from 'react';

import { TooltipProps as MuiTooltipProps, Tooltip } from '@material-ui/core';
import { ToggleButton, ToggleButtonProps } from '@material-ui/lab';

type TooltipToggleButtonProps = ToggleButtonProps & {
  TooltipProps: Omit<MuiTooltipProps, 'children'>;
};

export const TooltipToggleButton = forwardRef<
  HTMLButtonElement,
  TooltipToggleButtonProps
>(({ TooltipProps, ...props }, ref) =>
  props.disabled ? (
    <ToggleButton ref={ref} data-track-source-anchor="205e016c31;tooltip-toggle-button-toggle-button" {...props} />
  ) : (
    <Tooltip {...TooltipProps}>
      <ToggleButton ref={ref} data-track-source-anchor="3dcbe0358a;tooltip-toggle-button-toggle-button-2" {...props} />
    </Tooltip>
  ),
);
TooltipToggleButton.displayName = 'TooltipToggleButton';
